import { IListDataItem, IVideoListDataItem } from "../../../../constants/interfaces";

type Props = {
	data: IListDataItem | IVideoListDataItem;
	width: number;
	sum: number;
};

const Line = (props: Props) => {
	const data = props.data;
	const width = props.width;
	const sum = props.sum;

	return (
		<div className="list-item__line" style={{ width: width + "%" }}>
			{(data.relativeChannels ?? data.channels)
				.filter((c) => (c.total || 0) > 0)
				.map((channel, index) => {
					return (
						<div
							className="line-segment"
							key={index}
							style={{
								backgroundColor: channel.color,
								width: (channel.total / sum) * 100 + "%",
							}}
						/>
					);
				})}
		</div>
	);
};

export default Line;
